import {ContactPageComponent } from "../components/contactMain"

export const ContactPage = () => {
    return (
       <ContactPageComponent/>
    )
}